import React from 'react'
import { Box } from '@mui/material'
import styledFormInputs from '../../ui/inputs/styledFormInputs'


// One label + input. `fullWidth` fields span the whole row (forcing a line break);
// the rest are input-width cells so the two columns align.
const FieldCell = ({ input }) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: input.fullWidth ? '100%' : '220px' }}>
        {styledFormInputs([input])}
    </Box>
)


// Left-aligned layout: `fullWidth` fields (e.g. mac_address) sit alone on their row,
// the remaining fields flow two-per-row; on narrow screens they wrap to a single column.
const MacAddressFieldsGrid = ({ inputsData }) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            columnGap: '24px',
            width: '100%',
            maxWidth: '464px',
        }}
    >
        {inputsData.map((input, index) => (
            <FieldCell key={input.name || index} input={input} />
        ))}
    </Box>
)


export default MacAddressFieldsGrid
